import http, { httpV2 } from "../http";

const SettingsService = {
  get: (types) => httpV2.get(`/settings?types=${types.join(",")}`),
  set: (data) => httpV2.put(`/settings`, data),
  setGuestbookTabOrder: (tab_order) =>
    httpV2.put(`/settings/guestbook/tab-order`, { tab_order }),
  getGuestbookRevisions: () => httpV2.get(`/settings/guestbook/revisions`),
  saveGuestbookRevision: (state, label = "") =>
    httpV2.post(`/settings/guestbook/revisions`, { state, label }),
  restoreGuestbookRevision: (revisionId) =>
    httpV2.post(`/settings/guestbook/revisions/${revisionId}/restore`),
  createGuestbookPreviewToken: (rentalId) =>
    httpV2.post(`/settings/guestbook/preview-token`, { rental_id: rentalId }),
  getPmsFields: () => httpV2.get(`/list_pms_fields`),
};

export default SettingsService;
